import { AltiusRes } from "store/types";
import { AccountSettings } from "store/types";

import { AsyncActions, AsyncActionsParams } from "../base";

export interface IAccountActions {
  getAccountSettingsAction: () => Promise<AccountSettings>;
  updateAccountSettingsAction: (data: Partial<AccountSettings>) => Promise<AccountSettings>;
}

export class AccountActions extends AsyncActions implements IAccountActions {
  public constructor(params: AsyncActionsParams) {
    super(params);
  }

  public getAccountSettingsAction: IAccountActions["getAccountSettingsAction"] = async () => {
    const {
      data: { data: payload }
    } = await this.api.get<AltiusRes<AccountSettings>>({
      url: "/api/v0.0.3/account-settings"
    });
    return payload;
  };

  public updateAccountSettingsAction: IAccountActions["updateAccountSettingsAction"] = async (data) => {
    const {
      data: { data: payload }
    } = await this.api.patch<AltiusRes<AccountSettings>>({
      url: "/api/v0.0.3/account-settings",
      data
    });
    return payload;
  };
}
